import React, { useState } from "react";
import { CookieModal } from "./CookieModal";

const CookieButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <CookieModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <div
        className="bottom-4 left-8 z-10 fixed cursor-pointer"
        onClick={() => setIsOpen(true)}
      >
        <div className="flex justify-center items-center top-10 rounded-2xl bg-white border-2 border-[#188F46] w-12 h-12">
          <img src="/image/cookie.png" alt="" className="w-8 h-8" />
        </div>
      </div>
    </>
  );
};

export default CookieButton;
